import { render, staticRenderFns } from "./ProductMini.vue?vue&type=template&id=294d75d5&scoped=true"
import script from "./ProductMini.vue?vue&type=script&lang=js"
export * from "./ProductMini.vue?vue&type=script&lang=js"
import style0 from "./ProductMini.vue?vue&type=style&index=0&id=294d75d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294d75d5",
  null
  
)

export default component.exports